'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getStepsForMeals } from '@utils/Tasks';
import ChatActions from '@actions/ChatActions';
import { getTimeFormatted } from '@utils/Sunbasket';

export default class SunbasketDeadlineReminder extends Component {
    static contextTypes = {
        user: PropTypes.object,
        meals: PropTypes.array,
        recipes: PropTypes.object,
        details: PropTypes.object,
        foods: PropTypes.object,
    };

    componentDidMount() {
        this.processDeadlineReminders();
    }

    // Store previous context values in state to detect changes
    state = {
        prevUser: null,
        prevMeals: null,
        prevRecipes: null,
        prevDetails: null,
        prevFoods: null,
    };

    componentDidUpdate() {
        // Check for context changes by comparing with stored values
        const { user, meals, recipes, details, foods } = this.context;
        const { prevUser, prevMeals, prevRecipes, prevDetails, prevFoods } = this.state;

        // If component mounted or context changed, update state and process steps
        if (user !== prevUser || meals !== prevMeals || recipes !== prevRecipes ||
            details !== prevDetails || foods !== prevFoods) {

            // Update stored context values
            this.setState({
                prevUser: user,
                prevMeals: meals,
                prevRecipes: recipes,
                prevDetails: details,
                prevFoods: foods
            });

            this.processDeadlineReminders();
        }
    }

    processDeadlineReminders = () => {
        const { user, meals, recipes, details, foods } = this.context;

        if (!user || !meals || !recipes || !details || !foods) {
            return;
        }

        // Find just a list of the next 5 days meals
        const startDate = moment(), endDate = moment().add(5, 'day');
        const upcomingMeals = meals.filter(
            (meal) => startDate.isSameOrBefore(meal.date, 'day') && endDate.isSameOrAfter(meal.date, 'day')
        );

        // Filter steps for today
        const steps = getStepsForMeals(upcomingMeals, recipes, details, foods).filter((step) =>
            step.date.isSame(moment(), 'day') && step.type === 'sunbasket-deadline'
        );

        // Generate deadline message
        if (steps.length > 0) {
            const message = this.generateDeadlineMessage(steps);
            if (message) {
                setTimeout(() => ChatActions.updateFakeMessage('buy-sunbasket', message));
            }
        }
    }

    generateDeadlineMessage = (steps) => {
        if (!(steps && steps.length > 0)) {
            return null;
        }

        const deadline = steps[0].deadline;
        const currentDate = moment().startOf('days');

        if (deadline.diff(currentDate, 'days') == 2) {
            return 'Only two days left to order your sunbasket meals for the next week.';
        }

        if (deadline.diff(currentDate, 'days') == 1) {
            return 'Only one day left to order your Sunbasket meals for the next week.';
        }

        if (deadline.diff(currentDate, 'days') == 0 && moment().isBefore(deadline)) {
            return `Last day to order your Sunbasket meals for the next week. Order by ${getTimeFormatted(deadline)}!`;
        }

        return null;
    };

    render() {
        // This component doesn't render any UI
        return null;
    }
}
